import { Tooltip } from '../../components/utils/Tooltip';
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { DatePickerABX } from "../../components/pickers/DatePicker";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { useEffect, useState } from "react";
// import {Button} from 'abexa-estilos'



export const Requerimientos = () => {
    //ESTADOS
    const [ startDate, setStartDate ] = useState(() => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 30
    );
        return currentDate;
    })
    const [ endDate, setEndDate ] = useState(new Date());

    useEffect(()=> {
        document.title = "PGI | Requerimientos";
    },[])

    //VARIABLES 
    const idTbRequerimientos = "idRequerimientos"; 

    return(
        <>

            <ContenedorParametros titulo='Incidencias' tablaId={idTbRequerimientos}>   
                <BotonNuevo/>
            </ContenedorParametros>
            <div className='containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla flex w-[100%]'>
                <table className='tableResponsive'>
                    <thead>
                        <tr>
                            <th className="w-[3%]">N°</th>
                            <th className='w-[2%]'>TICKET</th>
                            <th className="w-[5%] whitespace-nowrap">F. REGISTRO</th>
                            <th className="w-[30%]">REQUERIMIENTO</th>
                            <th className="w-[20%]">EMPRESA</th>
                            <th className="w-[5%]">SOLICITANTE</th>
                            <th className='w-[10%]'>ESTADO</th>
                            <th className='w-[5%]'></th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>
        </>
    )
}